// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file <INSERT_FILE_DESCRIPTION_HERE>
 * @author James Reid
 */

// @ts-check

import { deckTweenCb, State } from "../../types/index.js"

/**
 * 
 * @param {deckTweenCb} callback 
 * @param {State} state 
 * @param {object} obj Optional destructured parameters object.
 * @param {number} [obj.start]
 * @param {number} [obj.end]
 * @param {number} [obj.duration]
 * @param {number} [obj.tweenStart]
 */
const tweenDeckEditor = (callback, state, {
    start = 0,
    end = 1,
    duration = 600,
    tweenStart = Date.now()
} = {}) => {
    const now = Date.now()

    if (now > tweenStart + duration) {
        callback(end)
        state.deckEditor.rerender()
    }
    else {
        window.requestAnimationFrame(() => {
            const timeProgress = (now - tweenStart) / duration
            const tweenProgress = timeProgress * (2 - timeProgress)
            callback(start + (end - start) * tweenProgress)

            tweenDeckEditor(callback, state, {
                start,
                end,
                duration,
                tweenStart
            })
        })
    }

    state.deckEditor.render()
}

export { tweenDeckEditor }
